import React from 'react'

import { Card } from '@newComponents/Card'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocScreenshot } from '../shared/DocScreenshot'

const Stripe = () => (
  <>
    <Card gap='$4'>
      <Paragraph size='$5'>
        Before you can charge for tickets, your Guild needs a connected Stripe
        account. Stripe handles payment processing, payouts, and regulatory
        compliance so you can focus on running great{' '}
        <Link href='/docs/events/overview'>Events</Link>.
      </Paragraph>
      <DocScreenshot
        src='docs/guilds/guild-settings-monetization.png'
        alt='Monetization settings page with Connect Stripe button — required before creating paid Event tickets'
        caption='Connect Stripe from your Guild Monetization settings to enable paid tickets'
      />
    </Card>

    <Card gap='$4'>
      <DocSection id='connecting-stripe' title='Connecting Stripe'>
        <Paragraph size='$5'>
          Open your Guild's{' '}
          <Link href='/docs/guilds/settings'>Guild Settings</Link> and go to the{' '}
          <Link href='/docs/guilds/monetization'>Monetization</Link> tab. Click{' '}
          <Paragraph size='$5' fontWeight='$7'>Connect Stripe</Paragraph> to
          launch the Stripe Connect onboarding flow. You will be guided through
          creating or linking a Stripe account, verifying your identity, and
          configuring payout preferences.
        </Paragraph>
        <Paragraph size='$5'>
          Once connected, every Event hosted by your Guild can offer paid{' '}
          <Link href='/docs/events/tiers'>ticketing tiers</Link>. Stripe deposits
          funds directly into your bank account on a rolling schedule. You can view
          transaction history, manage payouts, and process refunds from your Stripe
          dashboard at any time.
        </Paragraph>
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='free-events' title='Free Events'>
        <Paragraph size='$5'>
          If all of your tiers are free, you can skip this step entirely. Free
          tiers do not require a Stripe connection, so you can start collecting
          RSVPs immediately without any payment setup.
        </Paragraph>
        <Paragraph size='$5'>
          For the full guide on monetization features including Stripe setup and
          payout management, see{' '}
          <Link href='/docs/guilds/monetization'>Monetization</Link>.
        </Paragraph>
      </DocSection>
    </Card>
  </>
)

export default Stripe
